import styled, { css } from 'styled-components';

const FakeInput = styled.span`
  display: block;
  flex-shrink: 0;
  position: relative;
  width: 20px;
  height: 20px;
  border: 1px solid var(--light-gray);
  border: 1px solid ${({ $radioBorder }) => $radioBorder ?? 'var(--light-gray)'};
  /* border: 1px solid rgba(125, 131, 152, 0.3); */
  margin-right: 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  line-height: 1px;

  ${({ $labelReverse }) =>
    $labelReverse &&
    css`
      position: absolute;
      right: 0;
      margin: 0 0 0 10px;
    `}

  ${({ $indeterminate }) =>
    $indeterminate &&
    css`
      background: #0568fd;
      border-color: #0568fd;
      svg {
        opacity: 1;
      }
    `}

  ${({ $isChecked }) =>
    $isChecked &&
    css`
      background: #0568fd;
      border-color: #0568fd;
      svg {
        opacity: 1;
      }
    `}
`;

export default FakeInput;
